import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <g>
      <path
        fill={ fill }
        d="M23 4h-5.5V2.27C17.5 1.02 16.48 0 15.23 0H9.77C8.52 0 7.5 1.02 7.5 2.27V4H1c-.28 0-.5.22-.5.5s.22.5.5.5h2.81l2.05 18.55c.03.26.25.45.5.45h12.28c.25 0 .47-.19.5-.45L21.19 5H23c.28 0 .5-.22.5-.5S23.28 4 23 4zM8.5 2.27c0-.7.57-1.27 1.27-1.27h5.46c.7 0 1.27.57 1.27 1.27V4h-8V2.27zM18.19 23H6.81L4.82 5h15.36l-1.99 18z"
      />
      <path
        fill={ fill }
        className="prefix__st3"
        d="M10.26 9.23c-.28.02-.49.25-.47.53l.45 7.96c.01.27.24.47.5.47h.03c.28-.02.49-.25.47-.53l-.45-7.96c-.02-.27-.21-.49-.53-.47zM14.74 9.23c-.29-.03-.51.2-.53.47l-.44 7.96c-.02.28.2.51.47.53h.03c.26 0 .48-.21.5-.47l.44-7.96c.02-.28-.2-.51-.47-.53z"
      />
    </g>
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
